import { combineReducers } from 'redux'
import { AutoSyncTypes } from '../../action_types'

import { handleRequest, initialRequestState } from './helpers'

function getAutoSyncConfig(state = initialRequestState(), action) {
  return handleRequest(
    AutoSyncTypes.GET_AUTO_SYNC_CONFIG_REQUEST,
    AutoSyncTypes.GET_AUTO_SYNC_CONFIG_SUCCESS,
    AutoSyncTypes.GET_AUTO_SYNC_CONFIG_FAIL,
    state,
    action
  )
}

function toggleAutoSync(state = initialRequestState(), action) {
  return handleRequest(
    AutoSyncTypes.TOGGLE_AUTO_SYNC_REQUEST,
    AutoSyncTypes.TOGGLE_AUTO_SYNC_SUCCESS,
    AutoSyncTypes.TOGGLE_AUTO_SYNC_FAIL,
    state,
    action
  )
}

function createAutoSyncRule(state = initialRequestState(), action) {
  return handleRequest(
    AutoSyncTypes.CREATE_AUTO_SYNC_RULE_REQUEST,
    AutoSyncTypes.CREATE_AUTO_SYNC_RULE_SUCCESS,
    AutoSyncTypes.CREATE_AUTO_SYNC_RULE_FAIL,
    state,
    action
  )
}

function updateAutoSyncRule(state = initialRequestState(), action) {
  return handleRequest(
    AutoSyncTypes.UPDATE_AUTO_SYNC_RULE_REQUEST,
    AutoSyncTypes.UPDATE_AUTO_SYNC_RULE_SUCCESS,
    AutoSyncTypes.UPDATE_AUTO_SYNC_RULE_FAIL,
    state,
    action
  )
}

function deleteAutoSyncRule(state = initialRequestState(), action) {
  return handleRequest(
    AutoSyncTypes.DELETE_AUTO_SYNC_RULE_REQUEST,
    AutoSyncTypes.DELETE_AUTO_SYNC_RULE_SUCCESS,
    AutoSyncTypes.DELETE_AUTO_SYNC_RULE_FAIL,
    state,
    action
  )
}

export default combineReducers({
  getAutoSyncConfig,
  toggleAutoSync,
  createAutoSyncRule,
  updateAutoSyncRule,
  deleteAutoSyncRule,
})
